import React, { useState } from 'react';

export default function ChatWindow({ messages, socket, typingUser, user }) {
    const [text, setText] = useState("");

    function sendMessage() {
        if (!text.trim()) return;
        socket.emit("message", { username: user.username, text });
        setText("");
    }

    function handleTyping(event) {
        socket.emit("typing", user.username);
        setText(event.target.value);
    }

    return (
        <div className="chat-window">
            <div className="messages">
                {messages.map((msg) => (
                    <div key={msg._id} className="message">
                        <strong>{msg.username}:</strong> {msg.text}
                    </div>
                ))}
                {typingUser && <div className="typing">{typingUser} is typing...</div>}
            </div>

            <div className="input-bar">
                <input
                    value={text}
                    onChange={handleTyping}
                    placeholder="Type a message..."
                />
                <button onClick={sendMessage}>Send</button>
            </div>
        </div>
    );
}